import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { inr, today, formatApiError } from "../../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { askReason } from "../ApprovalLock";
import { field, label, SplitRows, BalanceBox, applyResult, rowsTotal } from "./shared";

const initialRows = (inv) => {
  const r = [];
  if (inv.paid_cash > 0) r.push({ method: "cash", amount: String(inv.paid_cash), reference: "" });
  if (inv.paid_online > 0) r.push({ method: "bank", amount: String(inv.paid_online), reference: "" });
  if (r.length === 0) r.push({ method: "cash", amount: String(inv.paid_amount || inv.balance || ""), reference: "" });
  return r;
};

export const PaymentModeDialog = ({ invoice, onClose, onChanged, user, reloadLocks }) => {
  const [date, setDate] = useState(today());
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (!invoice) return;
    setRows(initialRows(invoice)); setDate(today());
  }, [invoice]);

  const total = rowsTotal(rows);
  const save = async () => {
    const splits = rows.filter((r) => parseFloat(r.amount) > 0).map((r) => ({ method: r.method, amount: parseFloat(r.amount), reference: r.reference || "", bank_account: r.bank_account || "" }));
    if (splits.length === 0) return toast.error("Enter at least one amount");
    if (total > invoice.amount + 0.001) return toast.error(`Total exceeds invoice amount ${inr(invoice.amount)}`);
    const edit_reason = askReason(user, "changing payment method", invoice.invoice_no, true);
    if (edit_reason === null) return;
    try {
      const res = await api.put(`/invoices/${invoice.id}/payment-breakdown`, { date, splits, edit_reason });
      applyResult(res, "Payment mode updated", reloadLocks);
      onClose(); onChanged();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <Dialog open={!!invoice} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-card">
        <DialogHeader><DialogTitle className="font-display text-2xl">Payment Mode · {invoice?.invoice_no}</DialogTitle></DialogHeader>
        {invoice && (
          <div className="space-y-3">
            <BalanceBox title="Invoice amount · paid"><span className="num font-bold">{inr(invoice.amount)} · {inr(invoice.paid_amount)}</span></BalanceBox>
            <p className="text-xs text-muted-foreground">Split how this payment was received so cash & bank reconcile. Totals should match the paid amount.</p>
            <div>
              <label className={label}>Date</label>
              <input data-testid="pm-date" type="date" className={field + " num"} value={date} onChange={(e) => setDate(e.target.value)} />
            </div>
            <SplitRows rows={rows} setRows={setRows} prefix="pm" addTestid="pm-add" />
            <div className="flex justify-between items-center text-sm px-1">
              <span className="text-muted-foreground">Total</span>
              <span data-testid="pm-total" className={`num font-bold ${total > invoice.amount + 0.001 ? "text-destructive" : "text-foreground"}`}>{inr(total)}</span>
            </div>
          </div>
        )}
        <DialogFooter>
          <button data-testid="pm-save" onClick={save} className="h-10 px-5 rounded-md bg-accent text-accent-foreground font-medium hover:bg-accent/90 transition-colors">Save payment mode</button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
